const PUSH_PROMPT_KEY = "doitify_push_prompt";

const PROMPT_DISMISS_COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000;

function readStore() {
  try {
    const raw = localStorage.getItem(PUSH_PROMPT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
}

function writeStore(data) {
  try {
    localStorage.setItem(PUSH_PROMPT_KEY, JSON.stringify(data));
  } catch {
    /* quota exceeded or private browsing */
  }
}

export function shouldShowPushPrompt() {
  if (typeof window === "undefined") return false;
  if (!("Notification" in window)) return false;
  if (Notification.permission === "granted") return false;
  if (Notification.permission === "denied") return false;

  const store = readStore();
  if (!store) return true;

  if (store.accepted) return false;

  if (store.dismissedAt) {
    const dismissedAt = Number(store.dismissedAt);
    if (Number.isFinite(dismissedAt)) {
      const elapsed = Date.now() - dismissedAt;
      if (elapsed < PROMPT_DISMISS_COOLDOWN_MS) return false;
    }
  }

  return true;
}

export function persistPushPromptAccepted() {
  writeStore({ accepted: true, acceptedAt: Date.now() });
}

export function persistPushPromptDismissed() {
  const store = readStore();
  writeStore({
    ...(store?.accepted ? { accepted: true, acceptedAt: store.acceptedAt } : {}),
    dismissedAt: Date.now(),
  });
}
